// extracted by mini-css-extract-plugin
export default {"icon":"RJp4CARQZBODlB7jVftf","label":"DfjWls1jKOJ7yZJqs8V5","iconContainer":"Db_h4DJ6D8RRXqvnbmPy","labelContainer":"Um8m6MoUf5UTFsoLiHyj","inputContainer":"nW8lN8aBzl2v_JH8uCDq"};